import request from '@/http/request'

export const listAsnLine = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/warehouse/listAsnLine`, params)
}
export const getExportAsnLine = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/warehouse/exportAsnLine`, params)
}
